import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '@/i18n';
import { cn } from '@/lib/cn';

export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language).slice(0, 2);

  return (
    <div className={cn('flex items-center gap-2 text-xs', className)}>
      {supportedLanguages.map((lng, i) => (
        <span key={lng} className="flex items-center gap-2">
          {i > 0 && <span aria-hidden className="opacity-30">/</span>}
          <button
            type="button"
            onClick={() => void i18n.changeLanguage(lng)}
            aria-current={current === lng}
            className={cn(
              'uppercase tracking-[0.2em] transition-opacity',
              current === lng ? 'opacity-100' : 'opacity-40 hover:opacity-80',
            )}
          >
            {lng}
          </button>
        </span>
      ))}
    </div>
  );
}
